import { makeStyles } from '@material-ui/core/styles'
import i18n from 'i18next'
import React from 'react'

import api from 'src/api'
import { HopOnVehicle } from 'src/api/gen/api'
import { userHasPermission } from 'src/commons/permissions'
import { getJurisdictionTimezone, ZonedDateTimeToJSON } from 'src/commons/temporalHelpers'

import { IHopOnFilters } from './FilterPanel'
import VehiclesTable from './Table'

import { useFilters } from '.'

interface IProps {
  isLoading: boolean
  vehicles: HopOnVehicle[]
  vehiclesCount: number
}

function VehiclesList(props: IProps) {
  const classes = useStyles()

  const { vehicles, vehiclesCount, isLoading } = props
  const filters: IHopOnFilters = useFilters()

  let onClickExport
  if (userHasPermission(['analyze', 'device'])) {
    onClickExport = async function () {
      await api.hopon.hoponExport({
        status: Array.from(filters.status),
        updatedAt_after: filters.dateRange.from ? ZonedDateTimeToJSON(filters.dateRange.from) : undefined,
        updatedAt_before: filters.dateRange.to ? ZonedDateTimeToJSON(filters.dateRange.to) : undefined,
        tz: getJurisdictionTimezone(),
        lang: i18n.language,
      })
    }
  }

  return (
    <div className={classes.root}>
      <VehiclesTable data={vehicles} isLoading={isLoading} totalCount={vehiclesCount} onClickExport={onClickExport} />
    </div>
  )
}

const useStyles = makeStyles({
  root: {
    flex: 1,
    display: 'flex',
    borderTopRightRadius: 'inherit',
    borderBottomRightRadius: 'inherit',
  },
})

export default VehiclesList
